import * as React from "react";
const SvgTag = (props) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M10 24L22 12V2H12L0 14L10 24Z", fill: "black" }));
export default SvgTag;
